module.exports = __webpack_public_path__ + "img/star.85f3bc56.svg";